export default __webpack_public_path__ + "assets/thumbnail.6d31b534.webp";